import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useTitle } from 'util/title';
import { ZignalyLogotype, ZigStub, ZigTypography } from '@ui/index';
import { Box, Container } from '@mui/material';
import ReportProblemIcon from '@mui/icons-material/ReportProblem';
import { isZignaly, whitelabel } from 'whitelabel';
import { useCheckMaintenance } from '../../apis/appMeta/use';

const Maintenance: React.FC = () => {
  const { t } = useTranslation('error');
  useTitle(t('incident.title'));
  const logo = !isZignaly ? (
    <img src={whitelabel.logo} id='maintenance__logo' height='32' />
  ) : (
    <ZignalyLogotype width={'134px'} height={'32px'} id={'maintenance__logo'} />
  );

  useCheckMaintenance();

  return (
    <Container>
      <Box mt='14px'>
        <a href='/'>{logo}</a>

        <ZigStub
          title={
            <>
              <Box display='flex' alignItems='center' gap={1}>
                <ReportProblemIcon sx={{ fontSize: 28, color: 'yellow' }} />
                {t(`incident.title`)}
              </Box>
            </>
          }
          description={
            <>
              <ZigTypography
                variant={'h4'}
                sx={{ fontStyle: 'italic', mb: 3, fontWeight: 300 }}
              >
                {t(`incident.subtitle`)}
              </ZigTypography>

              <Trans t={t} i18nKey={'incident.description'}>
                <ZigTypography
                  component={'p'}
                  sx={{ mb: 1, textAlign: 'justify' }}
                />
              </Trans>
            </>
          }
        />
      </Box>
    </Container>
  );
};

export default Maintenance;
